export function integerNumberMask(number: number): string {
    // Verifica se o número é um número inteiro válido
    if (Number.isInteger(number)) {
        // Converte o número em uma string
        const numberString: string = number.toString();

        // Separa os dígitos em um array
        const digits: string[] = numberString.split("").reverse();

        // Aplica a máscara desejada (usando ponto como separador de milhares)
        const maskedNumber: string = digits.reduce(
            (acc: string, digit: string, index: number) => {
                if (index > 0 && index % 3 === 0) {
                    // Adicione um ponto a cada 3 dígitos
                    return `${acc}.${digit}`;
                }
                return acc + digit;
            },
            ""
        );

        return maskedNumber.split("").reverse().join("");
    }
    // Se o número não for um inteiro válido, retorne uma string vazia ou o próprio valor
    return "";
}

export function percentageMask(value?: string, signal = false): string {
    if (!value) return "";

    let cleaned = value.replace(/[^\d.]/g, "");

    cleaned = cleaned.replace(/^(\d*\.?\d{0,2}).*$/, "$1");
    cleaned = cleaned.replace(/^0+(?=\d)/, "");

    const numericValue = parseFloat(cleaned);

    if (!Number.isNaN(numericValue) && numericValue > 100) {
        return "100";
    }

    if (cleaned.includes(".")) {
        cleaned = cleaned.replace(/\.00$/, "").replace(/(\.\d)0$/, "$1");
    }

    return signal ? `${cleaned}%` : cleaned;
}
